// this function is used to check screen orientation

export function getScreenOrientation(): string {
  return window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
}
